"use client";

import Navbar from "@/components/ui/navbar";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import NotFoundLogo from "../../../../public/not-found.svg";
import Image from "next/image";
import CreatorProfile from "./components/creator-profile";
import usePublicProfileStore from "./public-profile.store";
import useSettingStore from "@/store/settings.store";
import { Footer } from "@/components/web/footer";
import LoadingComponent from "@/components/loading/loading-animation";

function HallaSheriUserPage({ params }: { params: { userName: string } }) {
  const [isLoading, setIsLoading] = useState(false);
  const { user, fetchProfileByUserName } = usePublicProfileStore();
  const { setTheme } = useSettingStore();
  useEffect(() => {
    let storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      setTheme(storedTheme === "true");
    }
  }, [setTheme]);

  useEffect(() => {
    setIsLoading(true);
    if (params.userName) {
      fetchProfileByUserName(params.userName)
        .then((data) => {
          if (data?.success) {
            setIsLoading(false);
          }
        })
        .catch(() => setIsLoading(false));
    }
  }, [params.userName, fetchProfileByUserName]);

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-neutral-900">
      {user && !isLoading ? (
        <>
          <Navbar
            fullName={user.full_name}
            userName={user.user_name ?? params?.userName}
            profileUrl={user?.profile_url}
          />

          <main className="flex flex-grow justify-center md:container">
            <CreatorProfile user={user} />
          </main>
          <Footer className="mt-5 bg-slate-100" />
        </>
      ) : !isLoading && !user ? (
        <NotFound />
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}

export default HallaSheriUserPage;

const NotFound = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-900">
      <div className="flex flex-col items-center justify-center rounded-lg bg-neutral-800 p-8 text-center shadow-lg">
        <Image
          priority
          src={NotFoundLogo}
          height={200}
          width={200}
          alt="Follow us on Twitter"
        />
        <h1 className="mb-4 text-2xl font-bold text-gray-200">
          Profile couldn&apos;t located
        </h1>

        <p className="mb-6 text-sm text-gray-300">
          Sorry, we couldn&apos;t find the profile you were looking for.
        </p>
        <Link
          href={"/"}
          className="rounded-lg bg-neutral-900 px-6 py-3 font-semibold text-white transition-colors hover:bg-neutral-950"
        >
          Go Back
        </Link>
      </div>
    </div>
  );
};
